import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// RequireAdmin — gate an authenticated + admin-only route. While the
// initial /api/auth/session probe is in flight, render a neutral
// loading state. Unauthenticated → /auth/login; authenticated but not
// admin → /  (home). Only sessions flagged `is_admin: true` pass.
export default function RequireAdmin({ children }) {
  const { loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "#0f0f0f", color: "#9a9a9a" }}
        data-testid="require-admin-loading"
      >
        <div className="text-xs" style={{ letterSpacing: "1px" }}>Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location.pathname + location.search }} replace />;
  }

  if (!user.is_admin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
